import { ROWS_PER_PAGE_TABLE_DEFAULT } from "@/core/utils/constants";

export class Page<T> {
    content: Array<T>;
    pageable: Pageable;
    last: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    sort: Array<any>;
    first: boolean;
    numberOfElements: number;
    empty: boolean;
}

class Pageable {
    sort: Array<any>;
    offset: number;
    pageSize: number;
    pageNumber: number;
    paged: boolean;
    unpaged: boolean;
}

export const pageDefault = () => {
    const page = new Page<any>();
    page.totalElements = 0;
    page.number = 0;
    page.size = ROWS_PER_PAGE_TABLE_DEFAULT;
    page.totalPages = 0;
    page.content = [];
    return page;
}

export const pageOneElement = (element: any) => {
    const page = new Page<any>();
    page.totalElements = 1;
    page.number = 0;
    page.size = 1;
    page.totalPages = 1;
    page.content = [element];
    return page;
}

export class PaginatorModel {
    totalPages: number = 0
    totalElements: number = 0;
    pageNumber: number = 0;
    pageSize: number = 0;

    public static newInstance(page: Page<any>): PaginatorModel {
        const instance: PaginatorModel = new PaginatorModel();
        instance.totalPages = page.totalPages;
        instance.totalElements = page.totalElements;
        instance.pageNumber = page.number;
        instance.pageSize = page.size;

        return instance;
    }

    public static newInstanceDefault() {
        return PaginatorModel.newInstance(pageDefault());
    }
}